import { videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function FeaturedSection() {
  const trending = videos.filter((v) => v.trending).slice(0, 6);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-5 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩内容</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {trending.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}